import questionnairesClient from '@/axiosClients/questionnairesClient';
import patientClient from '@/axiosClients/patientClient';

const getQuestionnaire = (questionnaireId) => questionnairesClient.get(`/questionnaire/${questionnaireId}`);
const saveQuestionnaire = (questionnaire) => questionnairesClient.post(`/questionnaire`, questionnaire);
const changeStatusQuestionnaire = (data) => questionnairesClient.post(`/questionnaire/evaluation/${data.questionnaireId}`, data);
const getQuestionnaireOthersAnswers = (questionnaireId) => questionnairesClient.get(`/questionnaire/show/${questionnaireId}`);
const getQuestionnaireInitialAnswers = (patientId) => questionnairesClient.get(`/questionnaire/initial/show/${patientId}`);
const assingQuestionnaireToPatient = (data) => questionnairesClient.post(`/patients/assign-questionnaire`, data);
const assingMassiveQuestionnaireToPatient = (data) => questionnairesClient.post(`/patients/massive-assign-questionnaire`, data);
const saveInitialTpt = (data) => patientClient.post(`/patient/update-tpt-information`, data);
const savePreferenceTpt = (data) => patientClient.post(`/patient/update-tpt-preference`, data);
const saveConsentParticipationGroupBalint = (data) => patientClient.post(`/patient/update-tpt-consent-participation-group-balint`, data);
const getPHQ9Result = (patientId) => questionnairesClient.get(`/questionnaire/result/phq9/${patientId}`);
const getGAD7Result = (patientId) => questionnairesClient.get(`/questionnaire/result/gad7/${patientId}`);
const getProQOLResult = (patientId) => questionnairesClient.get(`/questionnaire/result/proqol/${patientId}`);

export default {
    getQuestionnaire,
    saveQuestionnaire,
    changeStatusQuestionnaire,
    getQuestionnaireOthersAnswers,
    getQuestionnaireInitialAnswers,
    assingQuestionnaireToPatient,
    assingMassiveQuestionnaireToPatient,
    saveInitialTpt,
    savePreferenceTpt,
    saveConsentParticipationGroupBalint,
    getPHQ9Result,
    getGAD7Result,
    getProQOLResult
}
